import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Subject, firstValueFrom, takeUntil } from "rxjs";
import { Response } from "../../../_shared/models";
import { environment } from "../../../../environments/environment";
import { FuelKpiRequest } from "../../_shared";
import { FuelKpiSummaryResponse } from "../../_shared/models/fuel-kpi-response.model";
import { FuelInsightsRequest } from "../models/fuel-insights-request.model";

@Injectable({
  providedIn: 'root'
})
export class FuelConsumptionService {

  constructor(private http: HttpClient) { }

  public getFuelConsumptionSummary(request: FuelKpiRequest, cancellation: Subject<void>): Promise<Response<FuelKpiSummaryResponse>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/fueldashboard/fuel-consumption-dashboard-summary`, request).pipe(takeUntil(cancellation)));
  }

  public getGlobalFuelConsumptionEconomyInsights(request: FuelInsightsRequest, cancellation: Subject<void>): Promise<Response<any>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/fuelDashBoardInsights/global-fuel-economy`, request).pipe(takeUntil(cancellation)));
  }

  public getGlobalCostPerUnit(request: FuelInsightsRequest, cancellation: Subject<void>): Promise<Response<any>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/fuelDashBoardInsights/global-fuel-cost-per-unit`, request).pipe(takeUntil(cancellation)));
  }

  public getGlobalConsumptionInsights(request: FuelInsightsRequest, cancellation: Subject<void>): Promise<Response<any>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/fuelDashBoardInsights/global-fuel-consumption`, request).pipe(takeUntil(cancellation)));
  }

  public getGlobalVolumeInsights(request: FuelInsightsRequest, cancellation: Subject<void>): Promise<Response<any>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/fuelDashBoardInsights/global-fuel-volume`, request).pipe(takeUntil(cancellation)));
  }

  public getMovingFuelEconomyInsights(request: FuelInsightsRequest, cancellation: Subject<void>): Promise<Response<any>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/fuelDashBoardInsights/fuel-economy`, request).pipe(takeUntil(cancellation)));
  }

  public getMovingFuelConsumptionInsights(request: FuelInsightsRequest, cancellation: Subject<void>): Promise<Response<any>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/fuelDashBoardInsights/fuel-consumption`, request).pipe(takeUntil(cancellation)));
  }

  public getMovingFuelCostPerUnit(request: FuelInsightsRequest, cancellation: Subject<void>): Promise<Response<any>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/fuelDashBoardInsights/fuel-cost-per-unit`, request).pipe(takeUntil(cancellation)));
  }

  public getMovingFuelVolumeInsights(request: FuelInsightsRequest, cancellation: Subject<void>): Promise<Response<any>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/fuelDashBoardInsights/fuel-volume`, request).pipe(takeUntil(cancellation)));
  }
}